import React, { useState, createContext, useContext } from "react";
import { Layout, DatePicker, Typography } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import AppHeader from "./AppHeaderComponent";
import Sidebar from "./SideBarComponent";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Text } = Typography;

export type DateRange = [dayjs.Dayjs, dayjs.Dayjs];

interface DateRangeContextValue {
  dateRange: DateRange;
  setDateRange: (range: DateRange) => void;
}

const DateRangeContext = createContext<DateRangeContextValue>({
  dateRange: [dayjs().subtract(7, "day"), dayjs()],
  setDateRange: () => {},
});

export const useDateRange = () => useContext(DateRangeContext);

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [dateRange, setDateRange] = useState<DateRange>([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);

  return (
    <DateRangeContext.Provider value={{ dateRange, setDateRange }}>
      <Layout style={{ minHeight: "100vh" }}>
        <AppHeader />
        <Sidebar />
        <Content
          style={{
            marginTop: 64,
            marginLeft: 210,
            padding: 28,
            background: "var(--ant-color-bg-layout, #f1f5f9)",
          }}
        >
          {/* ─── Global Date Filter Bar ─── */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 10,
              marginBottom: 20,
              padding: "10px 16px",
              background: "#fff",
              borderRadius: 12,
              border: "1px solid #e2e8f0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            <FilterOutlined style={{ color: "#64748b", fontSize: 14 }} />
            <Text style={{ color: "#64748b", fontSize: 13, fontWeight: 500 }}>
              Date Range
            </Text>
            <RangePicker
              value={dateRange}
              onChange={(dates) => {
                if (dates && dates[0] && dates[1]) {
                  setDateRange([dates[0], dates[1]]);
                }
              }}
              format="DD MMM YYYY"
              allowClear={false}
              style={{ borderRadius: 8 }}
              presets={[
                { label: "Today", value: [dayjs(), dayjs()] },
                {
                  label: "Last 7 Days",
                  value: [dayjs().subtract(7, "day"), dayjs()],
                },
                {
                  label: "Last 30 Days",
                  value: [dayjs().subtract(30, "day"), dayjs()],
                },
                {
                  label: "This Month",
                  value: [dayjs().startOf("month"), dayjs()],
                },
                {
                  label: "Last Month",
                  value: [
                    dayjs().subtract(1, "month").startOf("month"),
                    dayjs().subtract(1, "month").endOf("month"),
                  ],
                },
              ]}
            />
          </div>

          <div className="app-content">{children}</div>
        </Content>
      </Layout>
    </DateRangeContext.Provider>
  );
};

export default AppLayout;
